var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("picture", [
    _c("source", {
      attrs: {
        srcset: _vm.mobileSrc ? _vm.mobileSrc : _vm.desktopSrc,
        media: "(max-width: 576px)"
      }
    }),
    _vm._v(" "),
    _c("img", {
      staticClass: "responsive-image",
      class: _vm.imageCss,
      attrs: { src: _vm.desktopSrc, alt: _vm.imageAlt }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }